import React from 'react';
import ConsultaRemessaListPageContainer from './ConsultaRemessaListPageContainer';

export class ConsultaRemessaListPage extends React.Component{
    
    render(){
      return (
        <ConsultaRemessaListPageContainer {...this.props}/>
      )
    }
}

